import { get, post, patch } from '@/request';
import { ClientJS } from 'clientjs';

const SERVICE = 'biz';

/**
 * 获取 clerk public key
 */

export const getClerkPublicKey = () => {
  return get('v1/auth/clerk/publishable-key', {}, { custom: { service: SERVICE } });
};

/**
 * 申请 waitlist
 * @param {*} params
 * @returns
 */
export const getAccessRequest = (params) => {
  return post('v1/waiting-list', params, { custom: { service: SERVICE } });
};

/**
 * 任务列表
 */
export const getTaskList = (params) => {
  return post('v1/tasks/search', params);
};

/**
 * 任务详情
 */
export const getTaskDetail = (taskId, data) => {
  return post(`v1/tasks/${taskId}/results/search`, data);
};

/**
 * 任务漏洞详情
 */
export const getVulDetail = (taskId, vulId) => {
  return get(`v1/tasks/${taskId}/results/${vulId}`);
};

/**
 * 任务删除
 */
export const deleteTask = (data) => {
  return post('v1/tasks/delete', data);
};

/**
 * 获取任务详情
 */
export const getTaskInfo = (taskId) => {
  return get(`v1/tasks/${taskId}`);
};

/**
 * 订单创建
 */
export const createOrder = (params) => {
  return post('v1/payment/stripe/create-payment-intent', params, { custom: { service: SERVICE } });
};

/**
 * 获取订单详情
 */
export const getOrderDetail = (orderId) => {
  return get(`v1/payment/orders/${orderId}`, {}, { custom: { service: SERVICE } });
};

/**
 * 取消支付订单
 */
export const cancelOrder = (orderId) => {
  return post(`v1/payment/orders/${orderId}/cancel`, {}, { custom: { service: SERVICE } });
};

/**
 * 获取 stripe public key
 */
export const getStripePublicKey = () => {
  return get('v1/payment/stripe/config', {}, { custom: { service: SERVICE } });
};

/**
 * 文件上传
 */
export const uploadFile = (params) => {
  return post('v1/files/upload', params, { headers: { 'Content-Type': 'multipart/form-data' } });
};

/**
 * 创建扫描任务
 */
export const createTask = (params) => {
  return post('v2/tasks', params);
};

/**
 * 创建网络连接诊断
 */
export const createNetworkDiagnosis = (params) => {
  return post('v1/network-diagnostics', params);
};

/**
 * 查询网络连接诊断
 */
export const getNetworkDiagnosis = (id, params = {}, custom = {}) => {
  return get(`v1/network-diagnostics/${id}/next-stage`, params, custom);
};

/**
 * 获取网站截图
 */
export const getWebsiteScreenshot = (params) => {
  return post('v2/tasks/check-sandbox', params, { responseType: 'arraybuffer' });
};

/**
 * 获取 source ip
 */
export const getSourceIp = () => {
  return get('v1/tasks/source-ip');
};

/**
 * 获取随机验证文本
 */
export const getRandomContent = () => {
  return get('v1/domain-ownership/random-content');
};

/**
 * 验证域名所有权
 */
export const verifyDomainOwnership = (params, manualHandleError = false) => {
  return post('v1/domain-ownership/verify', params, { custom: { manualHandleError } });
};

/**
 * 导出漏洞详情报告
 */
export const exportVulDetailReport = (taskId, params) => {
  return get(`v2/tasks/${taskId}/report`, params, { responseType: 'blob', headers: { 'Content-Type': 'application/octet-stream' }, custom: { responseOrigin: true } });
};

/**
 * 获取通知列表
 */
export const getNotifications = (params) => {
  return post('v1/notifications/search', params, { custom: { service: SERVICE } });
};

/**
 * 获取通知详情
 */
export const getNotificationDetail = (id) => {
  return get(`v1/notifications/${id}`, {}, { custom: { service: SERVICE } });
};

/**
 * 标记通知已读和mark
 */
export const markNotification = (params) => {
  return post('v1/notifications/update', params, { custom: { service: SERVICE } });
};

/**
 * 批量删除通知
 */
export const deleteNotifications = (params) => {
  return post('v1/notifications/delete', params, { custom: { service: SERVICE } });
};

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return get('v1/users/self/profile', {}, { custom: { service: SERVICE } });
};

/**
 * 更新用户信息
 */
export const updateUserInfo = (params) => {
  return patch('v1/users/self/profile', params, { custom: { service: SERVICE } });
};

/**
 * 获取支付方式
 */
export const getPaymentMethods = () => {
  return post('v1/payment/stripe/payment-methods/list', {}, { custom: { service: SERVICE } });
};

/**
 * 绑定支付方式
 */
export const bindPaymentMethod = (paymentMethodId) => {
  return post(`v1/payment/stripe/payment-methods/${paymentMethodId}/attach`, {}, { custom: { service: SERVICE } });
};

/**
 * 解绑支付方式
 */
export const unbindPaymentMethod = (paymentMethodId) => {
  return post(`v1/payment/stripe/payment-methods/${paymentMethodId}/detach`, {}, { custom: { service: SERVICE } });
};

/**
 * 获取已支付订单列表(支付历史)
 */
export const getPaymentHistory = (params) => {
  return post('v1/payment/orders/list-purchased', params, { custom: { service: SERVICE } });
};

/**
 * 获取申请信息
 */
export const getApplyInfo = () => {
  return get('v1/waiting-list/info', {}, { custom: { service: SERVICE, manualHandleError: true } });
};

/**
 * 获取通知设置
 */
export const getNotificationSettings = () => {
  return get('v1/notification-methods', {}, { custom: { service: SERVICE } });
};

/**
 * 更新通知设置
 */
export const updateNotificationSettings = (params) => {
  return patch('v1/notification-methods', params, { custom: { service: SERVICE } });
};

/**
 * 获取分享id
 */
export const getShareId = () => {
  return post('v1/shares/generate-id');
};

/**
 * 获取漏洞分享id
 */
export const getVulShareId = (params) => {
  return post('v1/shares', params);
};

/**
 * 更新漏洞分享时间
 */
export const updateVulShareTime = (shareId, params) => {
  return patch(`v1/shares/${shareId}`, params);
};

/**
 * 获取分享漏洞
 */
export const getVulShare = (shareId) => {
  return get(`v1/shares/public/${shareId}`);
};

/**
 * 获取分享漏洞详情
 */
export const getVulShareDetail = (shareId, vulId) => {
  return get(`v1/shares/public/${shareId}/vuls/${vulId}`);
};

/**
 * 获取分享列表
 */
export const getShareList = (params) => {
  return post('v1/shares/search', params);
};

/**
 * 删除分享列表
 */
export const deleteShareList = (params) => {
  return post('v1/shares/delete', params);
};

/**
 * 获取remote browser link
 */
export const getRemoteBrowserLink = (params) => {
  const client = new ClientJS();
  const fingerprint = client.getFingerprint();

  return post('v1/browsers', { ...params, clientId: fingerprint });
};

/**
 * 删除浏览器实例
 */
export const deleteBrowserInstance = (browserId) => {
  return post(`/${browserId}/delete`);
};

/**
 * 登录
 */
export const login = (params, manualHandleError = false) => {
  return post('v1/auth/login', params, { custom: { service: SERVICE, manualHandleError } });
};

/**
 * refresh token
 */
export const refreshAccessToken = (params) => {
  return post('v1/auth/exchange-token', params, { custom: { service: SERVICE } });
};

/**
 * logout
 */
export const logout = (params) => {
  return post('v1/auth/logout', params, { custom: { service: SERVICE } });
};

/**
 * get available-tokens
 */
export const getAvailableTokens = () => {
  return get('v1/licenses/available-tokens', {});
};

/**
 * get used-tokens
 */
export const getUsedTokens = () => {
  return get('v1/licenses/used-tokens', {});
};

/**
 * get token-history
 */
export const getTokenHistory = () => {
  return get('v1/licenses/list', {});
};

/**
 * token import
 */
export const tokenImport = (params) => {
  return post('v1/licenses/import', params);
};

/**
 * v1/licenses/list
 */
export const getLicenseList = (params) => {
  return post('v1/licenses/list', params);
};

/**
 * get network setting
 */
export const getNetworkSetting = () => {
  return get('v1/netplan/config');
};

/**
 * set network setting
 */
export const setNetworkSetting = (params) => {
  return post('v1/netplan/config', params);
};

/**
 * 修改密码
 */
export const changePassword = (params) => {
  return post('v1/users/change-password', params, { custom: { service: SERVICE } });
};

/**
 * 获取 origin 列表
 */
export const getOriginList = () => {
  return get('v1/waiting-list/origins', {}, { custom: { service: SERVICE } });
};

/**
 * 获取部署类型
 */
export const getDeployType = () => {
  return get('v1/config/deploy-type', {}, { custom: { service: SERVICE } });
};
